const statisticsFr = {
    "user_statistics": "Statistiques des utilisateurs",
    "menu_item_clicks": "Clics sur les éléments du menu",
    "statistics": "Statistiques",
    "user_traffic": "Trafic utilisateur",
    "last_7_days": "7 derniers jours",
    "last_30_days": "30 derniers jours",
    "menu_item": "Élément du menu",
    "click_count": "Nombre de clics",
    "error_fetching_user_statistics": "Erreur lors de la récupération des statistiques utilisateur.",
    "error_fetching_menu_item_statistics": "Erreur lors de la récupération des statistiques de l'élément de menu.",
    "statistics_feature_not_available": "La fonctionnalité de statistiques est uniquement disponible dans l'abonnement PRO. Veuillez passer à un abonnement supérieur pour y accéder.",
    "change_subscription_plan": "Changer d'abonnement",
    "permission_denied": "Accès refusé",
    "error_fetching_rating_statistics": "Erreur lors de la récupération des statistiques de notation.",
    "menu_item_ratings": "Évaluations des plats du menu",
    "likes": "goûts",
    "dislikes": "n'aime pas",
    "rating_trends_last_7_days": "Tendances des notes (7 derniers jours)",
    "rating_trends_last_30_days": "Évolution des notes (30 derniers jours)",
    "kpi_total_visitors": "Visiteurs totaux",
    "kpi_avg_per_day": "Moy. / jour",
    "kpi_peak_day": "Jour de pointe",
    "kpi_top_item": "Plat le plus cliqué",
    "kpi_clicks": "clics",
    "kpi_vs_prev": "vs période précédente",
    "current_period": "Période actuelle",
    "previous_period": "Période précédente",
    "visitors": "visiteurs",
    "hourly_traffic": "Trafic horaire",
    "utm_sources": "Sources de trafic",
    "utm_unknown": "Inconnu",
    "no_data": "Aucune donnée",
};

export default statisticsFr;
